<template>
  <search-form @search="searchResult"></search-form>
</template>

<script setup>
import dayjs from "dayjs";

const router = useRouter();

const searchResult = (payload) => {
  console.log(payload,'mrshah');
  router.push({
    name: "resultats",
    query: {
      origin: payload.origin?.id,
      destination: payload.destination?.id,
      dropfilter: payload.dropfilter,
      date: payload.date ? dayjs(payload.date).format("YYYY-MM-DD") : undefined,
    },
  });
};
</script>
